import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { confirmApi } from '../services/api';
import Logo from '../components/Logo';

const Confirm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState('loading'); // 'loading' | 'confirmed' | 'already' | 'error'
  const [reminderName, setReminderName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMsg('No confirmation token found in the link.');
      return;
    }

    if (hasCalledRef.current) return;
    hasCalledRef.current = true;

    confirmApi.confirm(token)
      .then((res) => {
        setReminderName(res.data.reminderName);
        setStatus(res.data.alreadyConfirmed ? 'already' : 'confirmed');
      })
      .catch((err) => {
        setErrorMsg(err.response?.data?.error || 'Invalid or expired confirmation link.');
        setStatus('error');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-xl shadow-lg p-12 max-w-md w-full text-center">
        <Logo size={48} className="mx-auto mb-4" />

        {status === 'loading' && (
          <div>
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <p className="text-gray-500">Confirming...</p>
          </div>
        )}

        {status === 'confirmed' && (
          <div>
            <div className="text-5xl mb-4">&#10003;</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Confirmed!</h1>
            {reminderName && (
              <p className="text-gray-600 mb-2">
                Your receipt of <strong>{reminderName}</strong> has been recorded.
              </p>
            )}
            <p className="text-gray-500 text-sm">You can close this tab.</p>
          </div>
        )}

        {status === 'already' && (
          <div>
            <div className="text-5xl mb-4">&#10003;</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Already Confirmed</h1>
            {reminderName && (
              <p className="text-gray-600 mb-2">
                <strong>{reminderName}</strong> was already confirmed.
              </p>
            )}
            <p className="text-gray-500 text-sm">You can close this tab.</p>
          </div>
        )}

        {status === 'error' && (
          <div>
            <div className="text-5xl mb-4">&#10060;</div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Link Not Valid</h1>
            <p className="text-gray-500 text-sm">{errorMsg}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Confirm;
